import './navReports.css';

export default function NavReports() {
    return(
        <div>
            <svg width="21.38" height="21.38" viewBox="0 0 21.38 21.38">
                <path id="Icon_ion-ios-paper" data-name="Icon ion-ios-paper" d="M7.281,5.02V21.568a.72.72,0,0,1-1.439,0V6.664H5.02A1.643,1.643,0,0,0,3.375,8.309v14.8A1.643,1.643,0,0,0,5.02,24.755H23.167a1.589,1.589,0,0,0,1.588-1.588V5.02A1.643,1.643,0,0,0,23.11,3.375l-14.287.1A1.473,1.473,0,0,0,7.281,5.02Zm3.392,1.645H14.99a.72.72,0,1,1,0,1.439H10.673a.72.72,0,1,1,0-1.439Zm0,8.223h7.606a.72.72,0,1,1,0,1.439H10.673a.72.72,0,1,1,0-1.439Zm10.073,5.55H10.673a.72.72,0,1,1,0-1.439H20.746a.72.72,0,1,1,0,1.439Zm0-8.223H10.673a.72.72,0,1,1,0-1.439H20.746a.72.72,0,1,1,0,1.439Z" transform="translate(-3.375 -3.375)" fill="#88cdf6"/>
            </svg>
        </div>
    )
}